export default __webpack_public_path__ + "static/media/apple-app-store-compound.4a3d59a1.svg";